import React from "react";
import { useShop } from "providers/ShopProvider";
import { Heading, Banner, TextContainer } from "@shopify/polaris";

export default function SandboxModeAlert() {
  const { shop } = useShop();

  console.log("Real ID :: shop sandboxmode", shop.sandboxMode);

  return (
    <div className="ri-my-4">
      {shop.sandboxMode && (
        <Banner
          status="info"
          action={{
            content: "Go Live",
            url: "https://dashboard.getverdict.com?utm_source=wc-plugin&utm_campaign=live-mode-button",
          }}
          secondaryAction={{
            url: "https://getverdict.com/help/docs/getting-started/test-mode?utm-source=wc-plugin",
            external: true,
            content: "Learn more",
          }}
        >
          <Heading>Test mode</Heading>
          <TextContainer>
            <p className="ri-mb-3">
              Real ID is currently in test mode. All features are accessible and
              you can send test ID checks are free of charge.
            </p>
          </TextContainer>
        </Banner>
      )}
    </div>
  );
}
